import { render } from "./ValoresSugeridos.vue?vue&type=template&id=e37f0f16&scoped=true&ts=true"
import script from "./ValoresSugeridos.vue?vue&type=script&lang=ts"
export * from "./ValoresSugeridos.vue?vue&type=script&lang=ts"

import "./ValoresSugeridos.vue?vue&type=style&index=0&id=e37f0f16&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e37f0f16"]])

export default __exports__